/* Build Your Stack mobile-only double-pull header reveal. Never changes global header behavior. */
(function(){
  function initialize(){
    var body=document.body;
    if(!body||!body.classList.contains('cl-page--stack'))return;
    if(!window.matchMedia('(max-width:749px)').matches)return;
    if(body.dataset.clStackDoublePullReady==='1')return;
    var shell=document.querySelector('.clai-shell[data-clai-header]');
    var host=shell&&shell.closest('.shopify-section');
    if(!shell||!host)return;
    body.dataset.clStackDoublePullReady='1';
    host.classList.add('cl-stack-header-host');
    var spacer=document.createElement('div');
    spacer.className='cl-stack-header-spacer';
    spacer.setAttribute('aria-hidden','true');
    host.insertAdjacentElement('afterend',spacer);
    function measure(){
      var h=Math.max(48,Math.ceil(shell.getBoundingClientRect().height||72));
      body.style.setProperty('--cl-stack-header-height',h+'px');
      spacer.style.height=h+'px';
    }
    function drawerOpen(){return !!shell.querySelector('.clai-menu[open]');}
    function reveal(){
      body.classList.remove('cl-stack-header--hidden');
      body.classList.add('cl-stack-header--shown');
    }
    function conceal(){
      if(drawerOpen())return;
      body.classList.remove('cl-stack-header--shown');
      body.classList.add('cl-stack-header--hidden');
    }
    reveal();
    measure();
    window.addEventListener('resize',measure,{passive:true});
    if(window.ResizeObserver){new ResizeObserver(measure).observe(shell);}
    var previousY=Math.max(0,window.scrollY||0);
    window.addEventListener('scroll',function(){
      var y=Math.max(0,window.scrollY||0);
      if(y<=8||drawerOpen())reveal();
      else if(y>75&&y-previousY>4)conceal();
      previousY=y;
    },{passive:true});
    shell.addEventListener('focusin',reveal);
    var touchStart=null,pullCount=0,lastPullAt=0;
    document.addEventListener('touchstart',function(e){
      if(!e.touches||e.touches.length!==1)return;
      if(e.target.closest('dialog,.clai-drawer,[data-mobile-tray],input,textarea,select'))return;
      touchStart={x:e.touches[0].clientX,y:e.touches[0].clientY};
    },{passive:true});
    document.addEventListener('touchend',function(e){
      if(!touchStart||!e.changedTouches||!e.changedTouches.length)return;
      var dx=e.changedTouches[0].clientX-touchStart.x;
      var dy=e.changedTouches[0].clientY-touchStart.y;
      touchStart=null;
      if(window.scrollY<45||Math.abs(dx)>90||Math.abs(dx)>Math.abs(dy)){pullCount=0;return;}
      if(dy>38){
        var now=Date.now();
        pullCount=(now-lastPullAt<2000)?pullCount+1:1;
        lastPullAt=now;
        if(pullCount>=2){pullCount=0;reveal();}
      }else if(dy< -38){pullCount=0;conceal();}
    },{passive:true});
    document.addEventListener('touchcancel',function(){touchStart=null;},{passive:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});
  else initialize();
  document.addEventListener('shopify:section:load',initialize);
  window.addEventListener('resize',initialize,{passive:true});
})();